import { ImageScaleView, ImageScaleViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

export default class Match2PinchMovesIcon extends ImageScaleView {
  constructor(
    opts: Omit<
      ImageScaleViewOpts,
      'image' | 'width' | 'height' | 'centerOnOrigin' | 'centerAnchor'
    > & { amount: number },
  ) {
    super({
      ...opts,
      image: 'assets/ui/match2/common/pinch_moves.png',
      width: 208 * 0.55,
      height: 217 * 0.55,
      centerOnOrigin: true,
      centerAnchor: true,
    });

    new LangBitmapFontTextView({
      superview: this,
      font: 'Title',
      color: '#FFFFFF',
      size: 45,
      x: this.style.width * 0.5 + 22,
      y: this.style.height * 0.5 - 2,
      centerOnOrigin: true,
      centerAnchor: true,
      localeText: () => `+${opts.amount}`,
      verticalAlign: 'center',
      align: 'center',
    });
  }
}
